module.exports = __webpack_public_path__ + "img/letter_L_PNG66.f7d98329.png";